

interface Service {
  img: string
  title: string
}

interface ExpertiseSectionProps {
  services?: Service[]
}

const ExpertiseSection = ({
  services = [],
}: ExpertiseSectionProps) => {
  return (
    <div className="experties">
      <div className="mx-auto grid grid-cols-2 gap-5 p-2 sm:grid-cols-2 md:grid-cols-3">
        {services.map((service, index) => (
          <div
            key={`${service.title}-${index}`}
            className="experties--box relative flex h-28 flex-col items-center justify-around rounded-[12px] border p-3 transition-all duration-300 sm:rounded-[28px] sm:bg-white sm:hover:bg-gradient-to-r sm:hover:from-[#2EC4F3]/10 sm:hover:to-[#BFD633]/10 hover:border-[#2EC4F3]"
          >
            {/* Service Icon */}
            <div className="relative h-14 w-14">
              <img
                src={service.img}
                alt={service.title}
                className="h-full w-full object-contain"
              />
            </div>

            {/* Service Title */}
            <h3 className="text-center text-base font-bold sm:text-[20px] text-[#000000]">
              {service.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ExpertiseSection

